const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
const MFA_SETUP = 'MFA_SETUP';
const SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA';

// eslint-disable-next-line import/prefer-default-export
export const authChallenges = {
  NEW_PASSWORD_REQUIRED,
  MFA_SETUP,
  SOFTWARE_TOKEN_MFA,
};
